import Map from "../fragments/map";
import { useMapSetting } from "./settings/map-settings";


function MapPage() {
  const [mapSetting] = useMapSetting();

  return mapSetting?.initialMapPosition ? <Map search initialCenter={mapSetting.initialMapPosition.center} initialZoom={mapSetting.initialMapPosition.zoom} /> : <div>Karte wird geladen &hellip;</div>
}

export default MapPage;